var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Oops!")]),_c('h3',[_vm._v("The "+_vm._s(_vm.resource)+" you're looking for is not here.")]),_c('router-link',{attrs:{"to":{ name: 'course-list' }}},[_vm._v("Back to the home page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }